var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-link',{attrs:{"size":"small","to":_vm.link}},[_vm._t("default",[_vm._v("编辑")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }